var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DescriptionContainer } from "./subcomponents";
import DescriptionTerm from "./DescriptionTerm";
import DescriptionDetail from "./DescriptionDetail";
var DataElement = function (_a) {
    var additionalLabel = _a.additionalLabel, additionalValue = _a.additionalValue, className = _a.className, dataCy = _a.dataCy, _b = _a.isLargerText, isLargerText = _b === void 0 ? false : _b, label = _a.label, _c = _a.toolTipText, toolTipText = _c === void 0 ? null : _c, type = _a.type, value = _a.value, subAdditionalLabel = _a.subAdditionalLabel;
    return (_jsxs(DescriptionContainer, __assign({ className: className, "data-cy": dataCy }, { children: [_jsx(DescriptionTerm, { additionalLabel: additionalLabel, label: label, toolTipText: toolTipText, isLargerText: isLargerText }), _jsx(DescriptionDetail, { additionalValue: additionalValue, subAdditionalLabel: subAdditionalLabel, type: type, value: value, isLargerText: isLargerText })] })));
};
export default DataElement;
//# sourceMappingURL=DataElement.js.map